<div class="row">
    <h3>Your account is waiting for admin approval.</h3>
  </div>
